import { useState } from 'react';

import ButtonLoader from './ButtonLoader';
import CategoryPicker from './CategoryPicker';

const AddPotentialHireForm = ({ onSubmit, isLoading, onCloseClicked, categoryOptions, categoriesLoading }) => {
  const [fullName, setFullName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [category, setCategory] = useState('');
  const [notes, setNotes] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ fullName, phoneNumber, email, category, notes });
  };

  const inputClass = 'border border-ase-blue rounded-md px-3 py-2 text-sm w-full outline-none focus:ring-1 focus:ring-ase-blue';
  const labelClass = 'text-sm font-semibold';

  return (
    <div className="bg-white rounded-lg border border-ase-blue w-full md:w-[500px]">
      <div className="flex items-center justify-between text-lg bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <p>Add Potential Hire</p>
        <p onClick={onCloseClicked} className="font-bold cursor-pointer text-2xl">X</p>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4 p-4">
        <div className="flex flex-col gap-1">
          <label className={labelClass}>Full Name *</label>
          <input
            className={inputClass}
            value={fullName}
            onChange={e => setFullName(e.target.value)}
            required
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className={labelClass}>Phone Number *</label>
          <input
            className={inputClass}
            value={phoneNumber}
            onChange={e => setPhoneNumber(e.target.value)}
            required
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className={labelClass}>Email *</label>
          <input
            type="email"
            className={inputClass}
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className={labelClass}>Category</label>
          <CategoryPicker value={category} onChange={setCategory} options={categoryOptions} isLoading={categoriesLoading} />
        </div>

        <div className="flex flex-col gap-1">
          <label className={labelClass}>Notes</label>
          <textarea
            className={`${inputClass} resize-none`}
            value={notes}
            onChange={e => setNotes(e.target.value)}
            rows={3}
          />
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className="bg-ase-blue text-white font-semibold py-2 rounded-md text-sm disabled:opacity-60 flex items-center justify-center"
        >
          {isLoading ? <ButtonLoader /> : 'Add'}
        </button>
      </form>
    </div>
  );
};

export default AddPotentialHireForm;
